import styled from "@emotion/styled";

export const CommodityFilterTileWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  padding-top: 1.375rem;
`;
